import { app } from '../../../../../app';
import { Controller } from './extended.controller';

app.component('userProfileExtended', {
    bindings: {profile: '<'},
    controller: Controller,
    templateUrl: require('./extended.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/extended/extended.component.js